class CollapsibleElement extends HTMLElement {
  connectedCallback() {
    /** @type {string} */ this.collapsibleId = this.dataset.collapsibleId;
    /** @type {HTMLElement} */ this.controller = this.querySelector('[aria-controls]');
    /** @type {HTMLElement} */ this.target = this.controller.ariaControlsElements[0];
    /** @type {boolean} */ this.isOpen = this.controller.ariaExpanded === 'true';
    /** @type {Array<{id: string, isOpen: boolean}>} */ this.storedCollapsibles = JSON.parse(
      sessionStorage.getItem('storedCollapsibles') || '[]'
    );

    this.controller.addEventListener('click', () => this.toggle());
  }

  /**
   * Toggle the collapsible element
   */
  toggle() {
    this.isOpen ? this.close() : this.open();
    this.isOpen = !this.isOpen;
    this.saveState();
  }

  /**
   * Open the collapsible element
   */
  open() {
    this.target.ariaHidden = 'false';
    this.controller.ariaExpanded = 'true';
  }

  /**
   * Close the collapsible element
   */
  close() {
    this.target.ariaHidden = 'true';
    this.controller.ariaExpanded = 'false';
  }

  /**
   * Save the collapsible element state
   */
  saveState() {
    if (!this.collapsibleId) return;

    const storedCollapsibles = JSON.parse(sessionStorage.getItem('storedCollapsibles') || '[]');
    const existingCollapsible = storedCollapsibles.find(({ id }) => id === this.collapsibleId);

    if (existingCollapsible) {
      existingCollapsible.isOpen = this.isOpen;
    } else {
      storedCollapsibles.push({ id: this.collapsibleId, isOpen: this.isOpen });
    }
    sessionStorage.setItem('storedCollapsibles', JSON.stringify(storedCollapsibles));
  }
}

customElements.define('collapsible-element', CollapsibleElement);
